import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { getOverride } from '@confluence/meta';
import store from '../utils/persistent-storage';
import { domBind } from '../../lib/dom-event';

const template = (translate) => `
    <span class="minor-edit toolbar-item">
        <input id="notifyWatchers" name="notifyWatchers" value="true" type="checkbox" checked>
        <label for="notifyWatchers">
          <span>${translate('editor.minor.edit')}</span>
        </label>
    </span>
`;

const plugin = {
	init: (ed) => {
		ed.on('init', () => {
			const params = {
				contentId: getOverride('content-id'), // TODO: this as well as Confluence.Editor.getContentId() should be passed through 'ed' from Editor.props
				//defaultVersionComment : AJS.params.versionComment // Unused so why was it here?
			};
			const container = $('#rte-savebar-tinymce-plugin-point');
			container.append(template((s) => ed.translate(s)));
			const element = container[0].querySelector('input[id="notifyWatchers"]');
			// Get user setting from local storage and set it to the checkbox. Watch for changes and persist them.
			const userValue = store.get('notifyWatchers', params.contentId, true);
			if (userValue !== null) {
				element.checked = userValue;
			}
			domBind(element, 'change', () => {
				store.set('notifyWatchers', params.contentId, true, element.checked);
			});
		});
	},

	getInfo: () => ({
		longname: 'Confluence Notify Watchers',
		author: 'Atlassian',
		authorurl: 'http://www.atlassian.com',
		version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
	}),
};

export default () => {
	window.tinymce.create('tinymce.plugins.ConfluenceNotifyWatchers', plugin);
	window.tinymce.PluginManager.add(
		'confluencenotifywatchers',
		window.tinymce.plugins.ConfluenceNotifyWatchers,
	);
};
